// Zeepy Interactive Sleep Routine Builder — with nap toggle + full 24h logic

(function initWhenReady(init) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})(function initZeepyRoutine() {
  const section = document.getElementById("routine-builder");
  if (!section) return;

  const ageButtons = section.querySelectorAll(".routine-btn");
  const wakeInput = section.querySelector("#wakeTime");
  const output = section.querySelector("#routine-output");
  if (!ageButtons.length || !wakeInput || !output) return;

  // 🌙 base data by age
  const routineData = {
    2: { totalSleep: 13, overnight: 11, defaultNap: 1.5, wakeWindows: [5, 6] },
    3: { totalSleep: 12.5, overnight: 10.5, defaultNap: 1, wakeWindows: [6, 7] },
    4: { totalSleep: 11.5, overnight: 10.5, defaultNap: 0.5, wakeWindows: [7, 7] },
    5: { totalSleep: 11, overnight: 10, defaultNap: 0, wakeWindows: [7, 7] },
    6: { totalSleep: 10.5, overnight: 10, defaultNap: 0, wakeWindows: [7, 7] }
  };

  const phaseColours = {
    violet: "#6A0DAD",
    amber: "#FFB84D",
    yellow: "#FFD24D",
    blue: "#4DA6FF"
  };

  const minsFromHHMM = (t) => {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  };
  const hhmmFromMins = (mins) => {
    const m = ((mins % 1440) + 1440) % 1440;
    const h = Math.floor(m / 60);
    const mm = m % 60;
    const ampm = h >= 12 ? "pm" : "am";
    const h12 = ((h + 11) % 12) + 1;
    return `${h12}:${String(mm).padStart(2, "0")}${ampm}`;
  };

  // ⚙️ render output
  function render(age, wakeHHMM, napEnabled, napDuration) {
    const d = routineData[age];
    if (!d) return;
    const wake = wakeHHMM || "07:00";
    const wakeM = minsFromHHMM(wake);

    // use either selected or default nap
    const napHours = napEnabled ? napDuration : 0;

    // recalc overnight (so total sleep stays realistic)
    const totalSleep = d.overnight + napHours;
    const bedtimeM = (wakeM - d.overnight * 60 + 1440) % 1440;
    const violetStartM = (bedtimeM - 30 + 1440) % 1440;
    const yellowStartM = (wakeM - 15 + 1440) % 1440;

    // nap timing
    let napStartM, napEndM;
    if (napHours > 0) {
      napStartM = (wakeM + d.wakeWindows[0] * 60) % 1440;
      napEndM = (napStartM + napHours * 60) % 1440;
    }

    const morningWakeWindow = d.wakeWindows[0];
    const afternoonWakeWindow = d.wakeWindows[1];

    output.innerHTML = `
      <div class="routine-stats">
        <h3>Age ${age} Routine ${napHours > 0 ? "with" : "without"} nap</h3>
        <p><strong>Total sleep:</strong> ${totalSleep.toFixed(1)} hrs in 24h</p>
      </div>

      <div class="routine-grid">
        <div class="routine-card" style="border-left:6px solid ${phaseColours.blue};background:#f4faff;">
          <h4>☀️ Wake Time</h4>
          <p>Starts day at <strong>${hhmmFromMins(wakeM)}</strong>.</p>
        </div>

        ${
          napHours > 0
            ? `<div class="routine-card" style="border-left:6px solid ${phaseColours.amber};background:#fffaf2;">
                 <h4>😴 Nap</h4>
                 <p>${hhmmFromMins(napStartM)}–${hhmmFromMins(napEndM)} (${napHours}h nap)</p>
               </div>`
            : ""
        }

        <div class="routine-card" style="border-left:6px solid ${phaseColours.violet};background:#f9f5ff;">
  <h4>🌙 Violet — Wind-Down</h4>
  <p>Begins <strong>${hhmmFromMins(violetStartM)}</strong> (30 mins before bedtime).</p>
</div>



        <div class="routine-card" style="border-left:6px solid ${phaseColours.amber};background:#fffaf2;">
          <h4>💤 Amber — Soothing Sleep</h4>
          <p>Bedtime <strong>${hhmmFromMins(bedtimeM)}</strong> • Overnight ≈ ${d.overnight}h</p>
        </div>

        <div class="routine-card" style="border-left:6px solid ${phaseColours.yellow};background:#fffef5;">
          <h4>⏳ Yellow — Nearly Wake</h4>
          <p>Starts <strong>${hhmmFromMins(yellowStartM)}</strong> (15 mins before wake time).</p>
        </div>
      </div>

      <p class="small-note">24h balance: ${d.overnight}h overnight + ${napHours}h nap + ${
      morningWakeWindow + afternoonWakeWindow
    }h awake = ~24h.</p>
    `;
  }

  // 🧩 UI setup
  const napControls = document.createElement("div");
  napControls.className = "nap-controls";
  napControls.innerHTML = `
    <label>
      <input type="checkbox" id="includeNap" checked> Include nap
    </label>
    <label>
      Duration:
      <select id="napDuration">
        <option value="0.5">0.5 hr</option>
        <option value="1" selected>1 hr</option>
        <option value="1.5">1.5 hr</option>
        <option value="2">2 hr</option>
      </select>
    </label>
  `;
  section.querySelector(".routine-controls").appendChild(napControls);

  const includeNap = napControls.querySelector("#includeNap");
  const napDurationSelect = napControls.querySelector("#napDuration");

  function getActiveAge() {
    return section.querySelector('.routine-btn[aria-selected="true"]')?.dataset.age || "2";
  }

  function updateRender() {
    const age = getActiveAge();
    render(age, wakeInput.value, includeNap.checked, parseFloat(napDurationSelect.value));
  }

  // Listeners
  ageButtons.forEach((btn) =>
    btn.addEventListener("click", () => {
      ageButtons.forEach((b) => b.setAttribute("aria-selected", b === btn ? "true" : "false"));
      updateRender();
    })
  );
  wakeInput.addEventListener("input", updateRender);
  includeNap.addEventListener("change", updateRender);
  napDurationSelect.addEventListener("change", updateRender);

  // Initial
  ageButtons[0].setAttribute("aria-selected", "true");
  updateRender();
});